import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isAndroid, isIOS } from 'react-device-detect';
import { createGuestNewLandingUsage } from '../reducers/newLandingReducer';
import { CloakFileQR } from 'cloak-file-sdk-web';
import '../styles/landing-qr.css';

class NewLandingPageQR2 extends PureComponent {
  componentDidMount() {
    const url = new URL(window.location.href);
    const email = url.searchParams.get('email');
    const campaignId = url.searchParams.get('campaign_id');
    this.props.dispatch(createGuestNewLandingUsage(email, campaignId));

    document.body.style.backgroundImage = "url('/cloak/public/img/cloak-bkg-l.jpeg')";
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundPosition = "center";
  }

  componentWillUnmount() {
  }

  render() {
//     if (isAndroid) {
//         window.location.href = "https://play.google.com/store/apps/details?id=com.cloakapps.cloak";
//         return null;
//     } else if (isIOS) {
//         window.location.href = "https://apps.apple.com/us/app/cloak-encrypt/id1495943745";
//         return null;
//     }

  const handleMobileRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.cloakapps.cloak";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = "https://apps.apple.com/us/app/cloak-encrypt/id1495943745";
    } else {
      // Optional: Fallback for desktop users
      window.location.href = "https://play.google.com/store/apps/details?id=com.cloakapps.cloak";
    }
  };

    return (
      <div className="landing-container">

        <header className="landing-header">
          <h1>Encrypt Files in the Browser. Keep Keys on Your Phone.</h1>
          <p>
          Cloak simplifies secure file sharing without ever exposing your private key in the browser.
          </p>
        </header>

        <section className="steps-container">
          <div className="step-card">
            <div className="step-header">Step 1</div>
            <p className="step-text">
              Install the{' '}
              <span
                style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={handleMobileRedirect}
              >
                Cloak mobile app
              </span>
              : scan the QR code below, register a new account, and sign in.
            </p>

            <img
              src="/cloak/public/img/redirect_download.png"
              alt="Scan to download"
              className="step-image"
              style={{ cursor: 'pointer' }}
              onClick={handleMobileRedirect}
            />
          </div>

          <div className="step-card">
            <div className="step-header">Step 2</div>
            <p className="step-text">
              Upload a file to generate an encryption QR code. You can also drag & drop or choose files directly.
            </p>
            <div className="qr-wrapper">
              <CloakFileQR className="qr-component" />
            </div>
          </div>

          <div className="step-card">
            <div className="step-header">Step 3</div>
            <p className="step-text">
              In the mobile app, tap the QR icon, scan the code above, select recipients, and download your encrypted file.
            </p>
            <img
              src="/cloak/public/img/cloak-android-qr.png"
              alt="Scan in mobile app"
              className="step-image"
            />
          </div>
        </section>

        {/* Moved button below the cards */}
        <div className="install-button-wrapper">
          <a
            className="learn-more-button"
            href="https://www.cloakapps.com/cloak.html"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleMobileRedirect}
          >
            Install Cloak Mobile App now
          </a>
        </div>
      </div>
    );
  }
}

export default connect()(NewLandingPageQR2);
